const store = {
    // eslint-ignore-line
    // Global app stuff
    api:
        pgap || location.hostname !== 'localhost'
            ? `https://${pgap ? 'getcoral.app' : location.hostname}/api`
            : 'http://localhost:8600/api',
    isTestflight: false,
    offline: false,
    currentTab: 'home',
    exploreCardOpen: 0,
    // User & login stuff
    user: {
        id: 0,
        email: '',
        phone: '',
        createdAt: '',
        updatedAt: '',
        name: '',
        username: '',
        day: 0,
        currentCourseId: 0,
        isSubscribed: false,
        isAdmin: false,
        complianceSMS: {
            optOut: false
        },
        communication: {
            push: {
                pulse: true,
                activity: true,
                news: true
            },
            email: {
                pulse: false,
                activity: false,
                news: true
            },
            sms: {
                pulse: false,
                activity: false,
                news: false
            }
        }
    },
    myDevice: {
        id: 0,
        uuid: ''
    },
    fontSize: 'normal',
    onboardingCompleted: 0,
    // Global audio player
    audioSources: pgap ? ['temp.mp3'] : [],
    isPlaying: false,
    isLoadingAudio: false,
    isPlayingContent: '',
    isPlayingData: {
        id: 0, // This is a unit
        type: ''
    },
    // Database
    topics: [],
    topicsIndex: [],
    courses: [],
    coursesIndex: [],
    units: [],
    unitsIndex: [],
    fullDataIndex: [],
    traits: [],
    traitsIndex: [],
    products: [],
    RCproducts: [],
    // caches
    newExercises: [],
    newStories: [],
    newQuestions: [],
    attachment: {},
    nextMajor: 0,
    course: {
        id: 0,
        name: '',
        comingSoon: false
    },
    trackerData: {
        timeForTracker: false,
        countSinceLast: 0,
        lastOne: {
            choiceInt: 8,
            choiceText: '',
            period: '',
            createdAt: '',
            updatedAt: '2'
        }
    },
    timeOfLast: null,
    unit: {
        id: 0,
        title: '',
        data: {},
        slides: [],
        bookmarked: false,
        description: false,
        hasAudio: false
    },
    unit2: {
        id: 0,
        title: '',
        data: {},
        slides: [],
        bookmarked: false,
        description: false,
        hasAudio: false
    },
    unit3: {
        id: 0,
        title: '',
        data: {},
        slides: [],
        bookmarked: false,
        description: false,
        hasAudio: false
    },
    // User Progress & traits
    darkTheme: false,
    progress: [],
    partners: [],
    myEvents: [],
    unreadEvents: 0,
    myTraits: [999999],
    myValueTraits: [],
    myTopics: [],
    myBookmarks: [],
    takeSelected: false,
    loginMode: pgap ? 'phone' : 'email',
    home: {
        dailyCoral: [],
        dailyPoll: []
    }
};

export default store;
